/**
 * Les anciennes adresses `/v2/…`, renvoyées à leur nouvelle place.
 *
 * Depuis le 27 septembre 2026, les cahiers d'un enfant vivent dans sa fiche,
 * sous l'onglet « Entraînements » (`v2/chemins`). L'adresse `/v2` a pourtant
 * circulé : la PWA installée la garde dans son historique, un parent a pu la
 * noter, et `App.tsx` retient l'adresse demandée au travers de la connexion.
 * Sans cette redirection, elle tomberait sur la route de repli, qui renvoie au
 * tableau de bord — la même panne qu'au 25 septembre, où la V2 se lisait comme
 * une redirection.
 *
 * `/v2` seul ne nomme aucun enfant : il mène au tableau de bord, où la barre du
 * haut porte les prénoms.
 */

import { Navigate, useLocation, useParams } from "react-router-dom";

import { depuisLAncienneAdresse } from "@/v2/chemins";

export function AncienneAdresseDeLEnfant() {
  const { childId = "", "*": reste = "" } = useParams();
  const { search } = useLocation();
  return <Navigate to={`${depuisLAncienneAdresse(childId, reste)}${search}`} replace />;
}
